import { SelectOption } from '@web-for-marketing/react-ui';
import { JurisdictionCode } from './jurisdictions';

export interface TimezoneSelectOption extends SelectOption {
    jurisdiction: JurisdictionCode;
}

export const timezoneOptions: TimezoneSelectOption[] = [
    // USA
    { value: 'America/New_York', content: 'Eastern Time (New York) - UTC-5', jurisdiction: JurisdictionCode.USA },
    { value: 'America/Chicago', content: 'Central Time (Chicago) - UTC-6', jurisdiction: JurisdictionCode.USA },
    { value: 'America/Denver', content: 'Mountain Time (Denver) - UTC-7', jurisdiction: JurisdictionCode.USA },
    { value: 'America/Los_Angeles', content: 'Pacific Time (Los Angeles) - UTC-8', jurisdiction: JurisdictionCode.USA },
    { value: 'America/Anchorage', content: 'Alaska Time (Anchorage) - UTC-9', jurisdiction: JurisdictionCode.USA },
    { value: 'Pacific/Honolulu', content: 'Hawaii Time (Honolulu) - UTC-10', jurisdiction: JurisdictionCode.USA },
    {
        value: 'America/Phoenix',
        content: 'Mountain Standard Time (Phoenix) - UTC-7',
        jurisdiction: JurisdictionCode.USA,
    },

    // Mexico (USA jurisdiction)
    { value: 'America/Mexico_City', content: 'Central Time (Mexico City) - UTC-6', jurisdiction: JurisdictionCode.USA },
    { value: 'America/Cancun', content: 'Eastern Time (Cancún) - UTC-5', jurisdiction: JurisdictionCode.USA },
    { value: 'America/Tijuana', content: 'Pacific Time (Tijuana) - UTC-8', jurisdiction: JurisdictionCode.USA },
    { value: 'America/Mazatlan', content: 'Mountain Time (Mazatlán) - UTC-7', jurisdiction: JurisdictionCode.USA },

    // Canada
    {
        value: 'America/St_Johns',
        content: 'Newfoundland Time (St. Johns) - UTC-3:30',
        jurisdiction: JurisdictionCode.Canada,
    },
    { value: 'America/Halifax', content: 'Atlantic Time (Halifax) - UTC-4', jurisdiction: JurisdictionCode.Canada },
    { value: 'America/Toronto', content: 'Eastern Time (Toronto) - UTC-5', jurisdiction: JurisdictionCode.Canada },
    { value: 'America/Winnipeg', content: 'Central Time (Winnipeg) - UTC-6', jurisdiction: JurisdictionCode.Canada },
    { value: 'America/Edmonton', content: 'Mountain Time (Edmonton) - UTC-7', jurisdiction: JurisdictionCode.Canada },
    { value: 'America/Vancouver', content: 'Pacific Time (Vancouver) - UTC-8', jurisdiction: JurisdictionCode.Canada },

    // South America (Brazil jurisdiction)
    { value: 'America/Sao_Paulo', content: 'Brasília Time (São Paulo) - UTC-3', jurisdiction: JurisdictionCode.Brazil },
    { value: 'America/Manaus', content: 'Amazon Time (Manaus) - UTC-4', jurisdiction: JurisdictionCode.Brazil },
    {
        value: 'America/Buenos_Aires',
        content: 'Argentina Time (Buenos Aires) - UTC-3',
        jurisdiction: JurisdictionCode.Brazil,
    },
    { value: 'America/Santiago', content: 'Chile Time (Santiago) - UTC-3', jurisdiction: JurisdictionCode.Brazil },
    { value: 'America/Lima', content: 'Peru Time (Lima) - UTC-5', jurisdiction: JurisdictionCode.Brazil },
    { value: 'America/Bogota', content: 'Colombia Time (Bogotá) - UTC-5', jurisdiction: JurisdictionCode.Brazil },
    {
        value: 'America/Guatemala',
        content: 'Central Time (Guatemala City) - UTC-6',
        jurisdiction: JurisdictionCode.Brazil,
    },
    { value: 'America/Costa_Rica', content: 'Central Time (San José) - UTC-6', jurisdiction: JurisdictionCode.Brazil },
    { value: 'America/Panama', content: 'Eastern Time (Panama City) - UTC-5', jurisdiction: JurisdictionCode.Brazil },
    { value: 'America/Jamaica', content: 'Eastern Time (Kingston) - UTC-5', jurisdiction: JurisdictionCode.Brazil },
    { value: 'America/Havana', content: 'Cuba Time (Havana) - UTC-5', jurisdiction: JurisdictionCode.Brazil },
    {
        value: 'America/Santo_Domingo',
        content: 'Atlantic Time (Santo Domingo) - UTC-4',
        jurisdiction: JurisdictionCode.Brazil,
    },
    {
        value: 'America/Puerto_Rico',
        content: 'Atlantic Time (San Juan) - UTC-4',
        jurisdiction: JurisdictionCode.Brazil,
    },

    // Europe
    { value: 'Europe/London', content: 'Greenwich Mean Time (London) - UTC+0', jurisdiction: JurisdictionCode.Europe },
    { value: 'Europe/Dublin', content: 'Irish Standard Time (Dublin) - UTC+0', jurisdiction: JurisdictionCode.Europe },
    {
        value: 'Europe/Lisbon',
        content: 'Western European Time (Lisbon) - UTC+0',
        jurisdiction: JurisdictionCode.Europe,
    },
    {
        value: 'Atlantic/Reykjavik',
        content: 'Greenwich Mean Time (Reykjavik) - UTC+0',
        jurisdiction: JurisdictionCode.Europe,
    },
    { value: 'Europe/Paris', content: 'Central European Time (Paris) - UTC+1', jurisdiction: JurisdictionCode.Europe },
    {
        value: 'Europe/Berlin',
        content: 'Central European Time (Berlin) - UTC+1',
        jurisdiction: JurisdictionCode.Europe,
    },
    {
        value: 'Europe/Madrid',
        content: 'Central European Time (Madrid) - UTC+1',
        jurisdiction: JurisdictionCode.Europe,
    },
    { value: 'Europe/Rome', content: 'Central European Time (Rome) - UTC+1', jurisdiction: JurisdictionCode.Europe },
    {
        value: 'Europe/Amsterdam',
        content: 'Central European Time (Amsterdam) - UTC+1',
        jurisdiction: JurisdictionCode.Europe,
    },
    {
        value: 'Europe/Brussels',
        content: 'Central European Time (Brussels) - UTC+1',
        jurisdiction: JurisdictionCode.Europe,
    },
    {
        value: 'Europe/Vienna',
        content: 'Central European Time (Vienna) - UTC+1',
        jurisdiction: JurisdictionCode.Europe,
    },
    {
        value: 'Europe/Zurich',
        content: 'Central European Time (Zurich) - UTC+1',
        jurisdiction: JurisdictionCode.Europe,
    },
    {
        value: 'Europe/Prague',
        content: 'Central European Time (Prague) - UTC+1',
        jurisdiction: JurisdictionCode.Europe,
    },
    {
        value: 'Europe/Warsaw',
        content: 'Central European Time (Warsaw) - UTC+1',
        jurisdiction: JurisdictionCode.Europe,
    },
    {
        value: 'Europe/Stockholm',
        content: 'Central European Time (Stockholm) - UTC+1',
        jurisdiction: JurisdictionCode.Europe,
    },
    { value: 'Europe/Oslo', content: 'Central European Time (Oslo) - UTC+1', jurisdiction: JurisdictionCode.Europe },
    {
        value: 'Europe/Copenhagen',
        content: 'Central European Time (Copenhagen) - UTC+1',
        jurisdiction: JurisdictionCode.Europe,
    },
    {
        value: 'Europe/Budapest',
        content: 'Central European Time (Budapest) - UTC+1',
        jurisdiction: JurisdictionCode.Europe,
    },
    {
        value: 'Europe/Belgrade',
        content: 'Central European Time (Belgrade) - UTC+1',
        jurisdiction: JurisdictionCode.Europe,
    },
    {
        value: 'Europe/Zagreb',
        content: 'Central European Time (Zagreb) - UTC+1',
        jurisdiction: JurisdictionCode.Europe,
    },
    {
        value: 'Europe/Ljubljana',
        content: 'Central European Time (Ljubljana) - UTC+1',
        jurisdiction: JurisdictionCode.Europe,
    },
    {
        value: 'Europe/Bratislava',
        content: 'Central European Time (Bratislava) - UTC+1',
        jurisdiction: JurisdictionCode.Europe,
    },
    {
        value: 'Europe/Helsinki',
        content: 'Eastern European Time (Helsinki) - UTC+2',
        jurisdiction: JurisdictionCode.Europe,
    },
    {
        value: 'Europe/Athens',
        content: 'Eastern European Time (Athens) - UTC+2',
        jurisdiction: JurisdictionCode.Europe,
    },
    {
        value: 'Europe/Bucharest',
        content: 'Eastern European Time (Bucharest) - UTC+2',
        jurisdiction: JurisdictionCode.Europe,
    },
    { value: 'Europe/Sofia', content: 'Eastern European Time (Sofia) - UTC+2', jurisdiction: JurisdictionCode.Europe },
    {
        value: 'Europe/Tallinn',
        content: 'Eastern European Time (Tallinn) - UTC+2',
        jurisdiction: JurisdictionCode.Europe,
    },
    { value: 'Europe/Riga', content: 'Eastern European Time (Riga) - UTC+2', jurisdiction: JurisdictionCode.Europe },
    {
        value: 'Europe/Vilnius',
        content: 'Eastern European Time (Vilnius) - UTC+2',
        jurisdiction: JurisdictionCode.Europe,
    },
    { value: 'Europe/Kiev', content: 'Eastern European Time (Kiev) - UTC+2', jurisdiction: JurisdictionCode.Europe },
    {
        value: 'Europe/Chisinau',
        content: 'Eastern European Time (Chisinau) - UTC+2',
        jurisdiction: JurisdictionCode.Europe,
    },
    { value: 'Europe/Moscow', content: 'Moscow Standard Time (Moscow) - UTC+3', jurisdiction: JurisdictionCode.Europe },
    { value: 'Europe/Minsk', content: 'Moscow Standard Time (Minsk) - UTC+3', jurisdiction: JurisdictionCode.Europe },

    // Africa
    {
        value: 'Africa/Casablanca',
        content: 'Western European Time (Casablanca) - UTC+0',
        jurisdiction: JurisdictionCode.Europe,
    },
    { value: 'Africa/Lagos', content: 'West Africa Time (Lagos) - UTC+1', jurisdiction: JurisdictionCode.Europe },
    { value: 'Africa/Cairo', content: 'Eastern European Time (Cairo) - UTC+2', jurisdiction: JurisdictionCode.Europe },
    {
        value: 'Africa/Johannesburg',
        content: 'South Africa Standard Time (Johannesburg) - UTC+2',
        jurisdiction: JurisdictionCode.Europe,
    },
    { value: 'Africa/Nairobi', content: 'East Africa Time (Nairobi) - UTC+3', jurisdiction: JurisdictionCode.Europe },
    {
        value: 'Africa/Algiers',
        content: 'Central European Time (Algiers) - UTC+1',
        jurisdiction: JurisdictionCode.Europe,
    },
    { value: 'Africa/Tunis', content: 'Central European Time (Tunis) - UTC+1', jurisdiction: JurisdictionCode.Europe },
    { value: 'Africa/Accra', content: 'Greenwich Mean Time (Accra) - UTC+0', jurisdiction: JurisdictionCode.Europe },
    {
        value: 'Africa/Addis_Ababa',
        content: 'East Africa Time (Addis Ababa) - UTC+3',
        jurisdiction: JurisdictionCode.Europe,
    },

    // Asia
    { value: 'Asia/Shanghai', content: 'China Standard Time (Shanghai) - UTC+8', jurisdiction: JurisdictionCode.Asia },
    { value: 'Asia/Hong_Kong', content: 'Hong Kong Time (Hong Kong) - UTC+8', jurisdiction: JurisdictionCode.Asia },
    { value: 'Asia/Tokyo', content: 'Japan Standard Time (Tokyo) - UTC+9', jurisdiction: JurisdictionCode.Asia },
    { value: 'Asia/Seoul', content: 'Korea Standard Time (Seoul) - UTC+9', jurisdiction: JurisdictionCode.Asia },
    { value: 'Asia/Taipei', content: 'China Standard Time (Taipei) - UTC+8', jurisdiction: JurisdictionCode.Asia },
    { value: 'Asia/Macau', content: 'China Standard Time (Macau) - UTC+8', jurisdiction: JurisdictionCode.Asia },
    {
        value: 'Asia/Singapore',
        content: 'Singapore Standard Time (Singapore) - UTC+8',
        jurisdiction: JurisdictionCode.Asia,
    },
    { value: 'Asia/Bangkok', content: 'Indochina Time (Bangkok) - UTC+7', jurisdiction: JurisdictionCode.Asia },
    { value: 'Asia/Jakarta', content: 'Western Indonesia Time (Jakarta) - UTC+7', jurisdiction: JurisdictionCode.Asia },
    { value: 'Asia/Manila', content: 'Philippine Standard Time (Manila) - UTC+8', jurisdiction: JurisdictionCode.Asia },
    {
        value: 'Asia/Kuala_Lumpur',
        content: 'Malaysia Time (Kuala Lumpur) - UTC+8',
        jurisdiction: JurisdictionCode.Asia,
    },
    {
        value: 'Asia/Ho_Chi_Minh',
        content: 'Indochina Time (Ho Chi Minh City) - UTC+7',
        jurisdiction: JurisdictionCode.Asia,
    },
    { value: 'Asia/Phnom_Penh', content: 'Indochina Time (Phnom Penh) - UTC+7', jurisdiction: JurisdictionCode.Asia },
    { value: 'Asia/Vientiane', content: 'Indochina Time (Vientiane) - UTC+7', jurisdiction: JurisdictionCode.Asia },
    { value: 'Asia/Yangon', content: 'Myanmar Time (Yangon) - UTC+6:30', jurisdiction: JurisdictionCode.Asia },
    { value: 'Asia/Brunei', content: 'Brunei Time (Bandar Seri Begawan) - UTC+8', jurisdiction: JurisdictionCode.Asia },
    {
        value: 'Asia/Kolkata',
        content: 'India Standard Time (Mumbai/Delhi) - UTC+5:30',
        jurisdiction: JurisdictionCode.Asia,
    },
    { value: 'Asia/Karachi', content: 'Pakistan Standard Time (Karachi) - UTC+5', jurisdiction: JurisdictionCode.Asia },
    { value: 'Asia/Dhaka', content: 'Bangladesh Standard Time (Dhaka) - UTC+6', jurisdiction: JurisdictionCode.Asia },
    {
        value: 'Asia/Colombo',
        content: 'Sri Lanka Standard Time (Colombo) - UTC+5:30',
        jurisdiction: JurisdictionCode.Asia,
    },
    { value: 'Asia/Kathmandu', content: 'Nepal Time (Kathmandu) - UTC+5:45', jurisdiction: JurisdictionCode.Asia },
    { value: 'Asia/Thimphu', content: 'Bhutan Time (Thimphu) - UTC+6', jurisdiction: JurisdictionCode.Asia },
    { value: 'Asia/Dubai', content: 'Gulf Standard Time (Dubai) - UTC+4', jurisdiction: JurisdictionCode.Asia },
    { value: 'Asia/Riyadh', content: 'Arabia Standard Time (Riyadh) - UTC+3', jurisdiction: JurisdictionCode.Asia },
    {
        value: 'Asia/Kuwait',
        content: 'Arabia Standard Time (Kuwait City) - UTC+3',
        jurisdiction: JurisdictionCode.Asia,
    },
    { value: 'Asia/Qatar', content: 'Arabia Standard Time (Doha) - UTC+3', jurisdiction: JurisdictionCode.Asia },
    { value: 'Asia/Bahrain', content: 'Arabia Standard Time (Manama) - UTC+3', jurisdiction: JurisdictionCode.Asia },
    { value: 'Asia/Muscat', content: 'Gulf Standard Time (Muscat) - UTC+4', jurisdiction: JurisdictionCode.Asia },
    { value: 'Asia/Tehran', content: 'Iran Standard Time (Tehran) - UTC+3:30', jurisdiction: JurisdictionCode.Asia },
    { value: 'Asia/Baghdad', content: 'Arabia Standard Time (Baghdad) - UTC+3', jurisdiction: JurisdictionCode.Asia },
    {
        value: 'Asia/Damascus',
        content: 'Eastern European Time (Damascus) - UTC+2',
        jurisdiction: JurisdictionCode.Asia,
    },
    { value: 'Asia/Beirut', content: 'Eastern European Time (Beirut) - UTC+2', jurisdiction: JurisdictionCode.Asia },
    {
        value: 'Asia/Jerusalem',
        content: 'Israel Standard Time (Jerusalem) - UTC+2',
        jurisdiction: JurisdictionCode.Asia,
    },
    { value: 'Asia/Amman', content: 'Eastern European Time (Amman) - UTC+2', jurisdiction: JurisdictionCode.Asia },
    { value: 'Asia/Istanbul', content: 'Turkey Time (Istanbul) - UTC+3', jurisdiction: JurisdictionCode.Asia },
    { value: 'Asia/Tashkent', content: 'Uzbekistan Time (Tashkent) - UTC+5', jurisdiction: JurisdictionCode.Asia },
    { value: 'Asia/Almaty', content: 'East Kazakhstan Time (Almaty) - UTC+6', jurisdiction: JurisdictionCode.Asia },
    { value: 'Asia/Bishkek', content: 'Kyrgyzstan Time (Bishkek) - UTC+6', jurisdiction: JurisdictionCode.Asia },
    { value: 'Asia/Dushanbe', content: 'Tajikistan Time (Dushanbe) - UTC+5', jurisdiction: JurisdictionCode.Asia },
    { value: 'Asia/Ashgabat', content: 'Turkmenistan Time (Ashgabat) - UTC+5', jurisdiction: JurisdictionCode.Asia },
    { value: 'Asia/Kabul', content: 'Afghanistan Time (Kabul) - UTC+4:30', jurisdiction: JurisdictionCode.Asia },
    { value: 'Asia/Tbilisi', content: 'Georgia Standard Time (Tbilisi) - UTC+4', jurisdiction: JurisdictionCode.Asia },
    { value: 'Asia/Yerevan', content: 'Armenia Time (Yerevan) - UTC+4', jurisdiction: JurisdictionCode.Asia },
    { value: 'Asia/Baku', content: 'Azerbaijan Time (Baku) - UTC+4', jurisdiction: JurisdictionCode.Asia },

    // Australia & Oceania
    {
        value: 'Australia/Sydney',
        content: 'Australian Eastern Time (Sydney) - UTC+10',
        jurisdiction: JurisdictionCode.Australia,
    },
    {
        value: 'Australia/Melbourne',
        content: 'Australian Eastern Time (Melbourne) - UTC+10',
        jurisdiction: JurisdictionCode.Australia,
    },
    {
        value: 'Australia/Brisbane',
        content: 'Australian Eastern Time (Brisbane) - UTC+10',
        jurisdiction: JurisdictionCode.Australia,
    },
    {
        value: 'Australia/Adelaide',
        content: 'Australian Central Time (Adelaide) - UTC+9:30',
        jurisdiction: JurisdictionCode.Australia,
    },
    {
        value: 'Australia/Darwin',
        content: 'Australian Central Time (Darwin) - UTC+9:30',
        jurisdiction: JurisdictionCode.Australia,
    },
    {
        value: 'Australia/Perth',
        content: 'Australian Western Time (Perth) - UTC+8',
        jurisdiction: JurisdictionCode.Australia,
    },
    {
        value: 'Australia/Hobart',
        content: 'Australian Eastern Time (Hobart) - UTC+10',
        jurisdiction: JurisdictionCode.Australia,
    },
    {
        value: 'Australia/Canberra',
        content: 'Australian Eastern Time (Canberra) - UTC+10',
        jurisdiction: JurisdictionCode.Australia,
    },
    {
        value: 'Pacific/Auckland',
        content: 'New Zealand Standard Time (Auckland) - UTC+12',
        jurisdiction: JurisdictionCode.Australia,
    },
    {
        value: 'Pacific/Chatham',
        content: 'Chatham Standard Time (Chatham Islands) - UTC+12:45',
        jurisdiction: JurisdictionCode.Australia,
    },
    { value: 'Pacific/Fiji', content: 'Fiji Time (Suva) - UTC+12', jurisdiction: JurisdictionCode.Australia },
    {
        value: 'Pacific/Port_Moresby',
        content: 'Papua New Guinea Time (Port Moresby) - UTC+10',
        jurisdiction: JurisdictionCode.Australia,
    },
    {
        value: 'Pacific/Noumea',
        content: 'New Caledonia Time (Nouméa) - UTC+11',
        jurisdiction: JurisdictionCode.Australia,
    },
    { value: 'Pacific/Apia', content: 'Samoa Standard Time (Apia) - UTC+13', jurisdiction: JurisdictionCode.Australia },
    {
        value: 'Pacific/Tongatapu',
        content: 'Tonga Time (Nuku\'alofa) - UTC+13',
        jurisdiction: JurisdictionCode.Australia,
    },
    { value: 'Pacific/Tahiti', content: 'Tahiti Time (Papeete) - UTC-10', jurisdiction: JurisdictionCode.Australia },
    {
        value: 'Pacific/Guadalcanal',
        content: 'Solomon Islands Time (Honiara) - UTC+11',
        jurisdiction: JurisdictionCode.Australia,
    },
    { value: 'Pacific/Efate', content: 'Vanuatu Time (Port Vila) - UTC+11', jurisdiction: JurisdictionCode.Australia },
];
